import { render } from "./course_section.vue?vue&type=template&id=6ad133ba&scoped=true&ts=true"
import script from "./course_section.vue?vue&type=script&lang=ts"
export * from "./course_section.vue?vue&type=script&lang=ts"

import "./course_section.vue?vue&type=style&index=0&id=6ad133ba&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad133ba"]])

export default __exports__